import React from 'react';
import { useSearchParams } from 'react-router-dom';

import CustomTabPanel from 'components/Shared/CustomTabPanel';
import CustomTabs from 'components/Shared/CustomTabs';
import RowsSkeleton from 'components/Shared/Skeleton/RowsSkeleton';
import NoteTab from '../../../Note/Notetab';

import { useDeliveryCollectionDetailContext } from "contexts/PaymentContexts/DeliveryCollectionDetailContext";
import { useGetNotesBySourceQuery } from "store/services/noteApi";
import { useGetDocumentsBySourceQuery } from "store/services/documentApi";

import DocumentsTab from "screens/App/CRM/Document/DocumentTab";
import DeliveryCollectionShipmentList from "./DeliveryCollectionShipmentList";
import { DeliveryCollectionPaymentDetailTab } from "./DeliveryCollectionPaymentDetailTab";

const DeliveryCollectionDetailTab = () => {

  const [searchParams] = useSearchParams();

  const activeTab = searchParams.get('tab') || 'note';

  const { deliveryCollectionDetail } = useDeliveryCollectionDetailContext();

  const { data: notes } = useGetNotesBySourceQuery(
    { source: 'DeliveryCollection', sourceRef: deliveryCollectionDetail?._id, }, { skip: !deliveryCollectionDetail?._id }
  );

  // Fetch documents to get the count for the badge
  const { data: documents } = useGetDocumentsBySourceQuery(
    { source: 'DeliveryCollection', sourceRef: deliveryCollectionDetail?._id, }, { skip: !deliveryCollectionDetail?._id }
  );

  const hasPaymentDetails = deliveryCollectionDetail?.paymentDetails &&
    typeof deliveryCollectionDetail.paymentDetails === 'object' &&
    Object.keys(deliveryCollectionDetail.paymentDetails).length > 0;

  const tabs = [
    {
      label: 'Note',
      value: 'note',
      badgeCount: notes?.length || 0,
    },
    { label: "Document", value: "document", badgeCount: documents?.totalItems },
    { label: "Shipment", value: "shipment", badgeCount: deliveryCollectionDetail?.shipment?.length },
    ...(hasPaymentDetails
      ? [{
        label: "Payment",
        value: "payment",
      }]
      : []
    ),
  ];

  return (
    <>
      <CustomTabs tabs={tabs} activeTab={activeTab} />

      {deliveryCollectionDetail ? (
        <>
          <CustomTabPanel activeTab={activeTab} value="note">
            <NoteTab source="DeliveryCollection" sourceRef={deliveryCollectionDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="document">
            <DocumentsTab source="DeliveryCollection" sourceRef={deliveryCollectionDetail._id} />
          </CustomTabPanel>

          <CustomTabPanel activeTab={activeTab} value="shipment">
            <DeliveryCollectionShipmentList />
          </CustomTabPanel>
          <CustomTabPanel activeTab={activeTab} value="payment">
            <DeliveryCollectionPaymentDetailTab />
          </CustomTabPanel>
        </>
      ) : (
        <RowsSkeleton />
      )}
    </>
  );
};

export default DeliveryCollectionDetailTab;